// index.js
import {store} from '../index'
import { FETCH_RESULT, TICK, STOP_TIMER, START_TIMER, SET_FILTER_SERIES, 
  SET_FILTER_SEURA, SET_FILTER_LAHTO, SET_FILTER_SIJA, SET_FILTER_MAALI, SET_FILTER_ERO, 
  SET_FILTER_HAKU, SET_FILTER_KERRAT, FETCH_LAST_VER,FETCH_LAST_VER_REFRESH, FETCH_VER, SORT_MAALI, SORT_SARJA } from './types'
//import {START_TIMER} from 'redux-timer-middleware'


import axios from 'axios';

//const apiUrl = 'http://localhost:4000/posts';
//const lresults_url = process.env.RESULTS

//const baseUrl = lresults_url ? lresults_url : 'http://localhost:3001/api/lresults'
//const baseUrl = 'http://localhost:3001/api/lresults'
const baseUrl = 'https://pirkankierros.herokuapp.com/api/lresults'

export const fetchResults = (lresults) => {
  //console.log('reload',lresults,lresults.results.length)
  if (lresults.results.length===0) {  //Onko uusia, jos nolla niin ei
    //console.log('fetch UPDATE: ',lresults.lastresult)
    return {
      type: FETCH_VER,
      ver: lresults.lastresult
    }
  }
 console.log("New Results",lresults.lastresult)
  
  return {
  type: FETCH_RESULT,
  results: lresults.results,
  ver: lresults.lastresult
  }
};

export const fetchVer= (ver) => {

   console.log('fetchVer: ',ver)
  return {
    type: FETCH_VER,
    ver: ver
  }
};

export const fetchLastver = (lastver) => {
console.log('fetchlastver: ',lastver)
  return {
    type: FETCH_LAST_VER,
    lastver: lastver
  }
};

export const fetchAllResults = () => {
  const { lastver, filtermaali } = store.getState()
  //console.log('pyyntö: ',ver,lastver)
  //2019/02/26 11:39:40.001
  //01234567890123456789012
  const furl=filtermaali !== '' ? baseUrl+'/'+lastver+'/'+filtermaali.substr(0,4)+filtermaali.substr(5,2)+
              filtermaali.substr(8,2)+filtermaali.substr(11,2)+filtermaali.substr(14,2)+
              filtermaali.substr(17,2)+filtermaali.substr(20,3) : baseUrl+'/'+lastver
  //console.log(furl)
  return (dispatch) => {
    return axios.get(furl)
      .then(response => {
        dispatch(fetchResults(response.data))
      })
      .catch(error => {
        throw(error);
      });
  };
};

export const fetchResultsVer = () => {
  return (dispatch) => {
    return axios.get(baseUrl+'/tail/1')
      .then(response => {
        dispatch(fetchVer(response.data))
      })
      .catch(error => {
        throw(error);
      });
  };
};


export const startTimer = (interval) => {
    return {
      type: START_TIMER,
      payload: {
      actionName: TICK,
     // actionPayload: fetchAllResults(),
      timerName: 'tarmo',
      timerInterval: interval
      }
    }
  }


export const stopTimer = () => {
  return {
    type: STOP_TIMER
  }
}

export const tickTimer = () => {

}

export const filterChangeSeries = (filterseries) => {
  return {
    type: SET_FILTER_SERIES,
    filterseries: filterseries
  }
}

export const filterChangeSeura = (filterseura) => {
  return {
    type: SET_FILTER_SEURA,
    filterseura: filterseura
  }
}


export const filterChangeLahto = (filterlahto) => {
  return {
    type: SET_FILTER_LAHTO,
    filterlahto: filterlahto
  }
}

export const filterChangeSija = (filtersija) => {
  return {
    type: SET_FILTER_SIJA,
    filtersija: filtersija
  }
}

export const filterChangeMaali = (filtermaali) => {
  if (filtermaali !== '' ) {
    return {
      type: SET_FILTER_MAALI,
      filtermaali: filtermaali
  }
  }
  return {
    type: FETCH_LAST_VER_REFRESH,
    filtermaali: filtermaali,
    ver: 0
  }
}

export const filterChangeEro = (filterero) => {
  return {
    type: SET_FILTER_ERO,
    filterero: filterero
  }
}

export const filterChangeHaku= (filterhaku) => {
  return {
    type: SET_FILTER_HAKU,
    filterhaku: filterhaku
  }
}

export const filterChangeKerrat = (filterkerrat) => {
  return {
    type: SET_FILTER_KERRAT,
    filterkerrat: filterkerrat
  }
}

export const sortChangeMaali = (sortmaali) => {
  return {
    type: SORT_MAALI,
    sortmaali: sortmaali
  }
}

export const sortChangeSarja = (sortsarja) => {
  return {
    type: SORT_SARJA,
    sortsarja: sortsarja
  }
}


